import React from "react";
import { AiOutlineShopping, AiTwotoneStar } from "react-icons/ai";

const Items = ({ setCartItems, popular_Sales, item, cartItems }) => {
  const { btn, color, img, price, rating, shadow, text, title } = item;
  const handleAddToCart = () => {
    setCartItems([...cartItems, item]);
  };

  return (
    <div
      className={`relative bg-gradient-to-b z-0 ${color}  ${
        popular_Sales
          ? " h-[30vh] rounded-md w-full flex items-center justify-between"
          : `w-full ${shadow} rounded-xl grid items-center justify-items-center`
      }    py-4 px-5  transition-all duration-700 ease-in-out hover:scale-105 `}
    >
      <div>
        <div className="grid items-center justify-items-center">
          <h1 className="text-slate-200 filter drop-shadow text-lg lg:text-3xl md:text-base font-medium ">
            {title}
          </h1>
          <p className="text-slate-200 filter drop-shadow lg:text-2xl md:text-normal">
            {text}
          </p>
        </div>
        <div className="flex items-center justify-between">
          <div className="bg-slate-200 rounded text-normal px-1 lg:3xl">${price}</div>
          <h1 className="flex items-center">
            <AiTwotoneStar className="text-yellow-500" />
            {rating}
          </h1>
        </div>
        <div className="flex items-center justify-between py-2">
          <AiOutlineShopping className=" text-5xl text-slate-300 cursor-pointer  shadow-sky-300 hover:scale-125 transition-all ease-out duration-200 " />
          <button
            onClick={handleAddToCart}
            className="blur-effect-theme button-theme px-2 py-1 text-normal lg:3xl lg:shadow-none text-black shadow-sky-300"
          >
            {btn}
          </button>
        </div>
      </div>
      <div>
        <img
          src={img}
          alt="img"
          className={`object-fill z-50 ${
            popular_Sales
              ? " h-25 w-[25vh] lg:h-29 lg:rotate-0 object-cover absolute bottom-0 right-0 -rotate-45"
              : "h-36"
          } hover:-rotate-45 cursor-pointer transition-all duration-200 ease-in-out`}
        />
      </div>
    </div>
  );
};

export default Items;
